import { IconCalendar, IconChevronLeft, IconChevronRight, IconRefresh, IconSearch, IconReload, IconX } from '@tabler/icons-react';
import moment from 'moment';
import React, { useEffect, useState, useMemo } from 'react';
import { DateRange } from 'react-date-range';
import { useNavigate } from 'react-router-dom';
import Input from '../../components/Input';
import { getAuthorizationHeader, http } from '../../config/http';
import Layouts from '../../layouts/Layouts';
import { DinamicTitle } from '../../utils/DinamicTitle';
import DetailBarangPenjualan from './DetailBarangPenjualan';
import { useMasterData } from '../../context/MasterDataContext';
import FilterDrawer, { FilterToggleButton, KaratGridFilter } from '../../components/FilterDrawer';

const TrxPenjualanV2 = () => {
  const navigate = useNavigate();
  const { kategoriList: kategori = [], cabangList = [] } = useMasterData() || {};
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const selectCabang = useMemo(() => {
    return (cabangList || []).filter(
      (cb) => cb.is_toko == 1 || cb.is_toko === true || !cb.nama_cabang?.toLowerCase().includes('brankas')
    );
  }, [cabangList]);

  const [selectedKarat, setSelectedKarat] = useState('');
  const [trxPenjualan, setTrxPenjualan] = useState([]);
  const [openLoading, setOpenLoading] = useState(false);
  const [detailPenjualan, setDetailPenjualan] = useState([]);
  const [loading, setLoading] = useState(false);
  const [idCabang, setIdCabang] = useState(0);

  const [openCalender, setOpenCalender] = useState(false);
  const [filterDate, setFilterDate] = useState(null);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [perPage, setPerPage] = useState(10);
  const awal = moment(startDate).format('DD-MM-YYYY');
  const akhir = moment(endDate).format('DD-MM-YYYY');

  const [filterBerat, setFilterBerat] = useState('');
  const [berat, setBerat] = useState('');

  const [isRefund, setIsRefund] = useState(0);
  const [activeTab, setActiveTab] = useState('Transaksi Penjualan');

  const [selectedKategori, setSelectedKategori] = useState('');
  const [selectJenisKategori, setSelectJenisKategori] = useState('');

  const handleKategoriChange = (event) => {
    setSelectedKategori(event.target.value);
    setSelectJenisKategori('');
    setCurrentPage(1);
  };

  const handleJenisKategoriChange = (event) => {
    setSelectJenisKategori(event.target.value);
    setCurrentPage(1);
  };

  const filterBeratBarang = () => {
    setBerat(filterBerat);
    setCurrentPage(1);
  };
  const [currentPage, setCurrentPage] = useState(1);
  const [pageInput, setPageInput] = useState('1');
  const [lastPage, setLastPage] = useState(0);
  const [search, setSearch] = useState('');
  const [reloadTrigger, setReloadTrigger] = useState(0);

  const activeFilterCount = [
    idCabang && idCabang !== '0',
    selectedKategori,
    selectJenisKategori,
    selectedKarat,
    berat,
  ].filter(Boolean).length;

  const handleResetAndReload = () => {
    setIdCabang(0);
    setSelectedKategori('');
    setSelectJenisKategori('');
    setSelectedKarat('');
    setFilterBerat('');
    setBerat('');
    setSearch('');
    setStartDate(new Date());
    setEndDate(new Date());
    setFilterDate(null);
    setCurrentPage(1);
    setReloadTrigger(prev => prev + 1);
  };

  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  const [itemsPerPage, setItemsPerPage] = useState('');
  const startIndex = (currentPage - 1) * itemsPerPage;

  useEffect(() => {
    async function getTrxPenjualan() {
      setLoading(true);
      const params = new URLSearchParams();
      if (search !== '') {
        params.append('faktur', search);
      } else {
        params.append('page', currentPage);
      }
      params.append('per_page', perPage);
      if (idCabang && idCabang !== 0 && idCabang !== '0') params.append('cabang', idCabang);
      if (selectedKategori && selectedKategori !== 0 && selectedKategori !== '0') params.append('kategori', selectedKategori);
      if (selectJenisKategori && selectJenisKategori !== 0 && selectJenisKategori !== '0') params.append('jenis_kategori', selectJenisKategori);
      if (startDate !== null && endDate !== null) {
        params.append('tgl_awal', awal);
        params.append('tgl_akhir', akhir);
      }
      if (selectedKarat) params.append('karat', selectedKarat);
      if (berat) params.append('berat', berat);
      if (activeTab === 'Penjualan Return') {
        params.append('is_refund', '1');
      } else {
        params.append('is_refund', '0');
      }

      await http
        .get(`penjualan?${params.toString()}`, {
          headers: { Authorization: getAuthorizationHeader() },
        })
        .then((res) => {
          setTrxPenjualan(res.data.data.data);
          setCurrentPage(res.data.data.current_page);
          setItemsPerPage(res.data.data.per_page);
          setLastPage(res.data.data.last_page);
          return res.data.data;
        })
        .catch((err) => {
          if (err.response === 'undefined') {
            return null;
          } else if (err.response?.status === 401) {
            navigate('/login');
          }
        });
      setLoading(false);
    }
    getTrxPenjualan();
  }, [
    idCabang,
    search.length >= 12 ? search : '',
    awal,
    akhir,
    startDate,
    endDate,
    currentPage,
    navigate,
    selectedKarat,
    berat,
    selectedKategori,
    selectJenisKategori,
    isRefund,
    reloadTrigger,
    activeTab,
    perPage
  ]);

  useEffect(() => {
    setPageInput(currentPage.toString());
  }, [currentPage]);

  const handlePageInputChange = (e) => {
    setPageInput(e.target.value);
  };

  const jumpToPage = () => {
    const pageNumber = parseInt(pageInput, 10);
    if (!isNaN(pageNumber) && pageNumber >= 1 && pageNumber <= lastPage) {
      setCurrentPage(pageNumber);
    } else {
      setPageInput(currentPage.toString());
    }
  };

  const handlePageInputKeyDown = (e) => {
    if (e.key === 'Enter') {
      jumpToPage();
      e.target.blur();
    }
  };

  let [isOpen, setIsOpen] = useState(false);

  function closeModal() {
    setIsOpen(false);
  }
  function showDetailPenjualan(trx) {
    setDetailPenjualan(trx);
    setIsOpen(true);
  }



  const selectionRange = {
    startDate: startDate,
    endDate: endDate,
    key: 'selection',
  };

  function handleSelect(date) {
    // console.log('date::: ', date);
    setStartDate(date.selection.startDate);
    setEndDate(date.selection.endDate);
  }

  function checkBerat(number) {
    const beratConfirm = parseFloat(number);
    return beratConfirm % 1 === 0
      ? beratConfirm.toString()
      : beratConfirm
        .toFixed(2)
        .replace(/\.?0+$/, '')
        .replace('.', ',');
  }

  DinamicTitle('Transaksi Penjualan || Komaladewi');

  return (
    <Layouts
      // title={'Transaksi Penjualan'}
      compFilter={null}
    >
      <div className="mt-4 md:mt-0">
        <div className="flex space-x-4 border-b border-slate-200 dark:border-slate-800 mb-2">
          <button
            className={`px-4 py-2 text-sm font-bold transition-colors border-b-2 ${
              activeTab === 'Transaksi Penjualan'
                ? 'border-amber-500 text-amber-600 dark:text-amber-400'
                : 'border-transparent text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200'
            }`}
            onClick={() => {
              setActiveTab('Transaksi Penjualan');
              setCurrentPage(1);
            }}
          >
            TRX Penjualan
          </button>
          <button
            className={`px-4 py-2 text-sm font-bold transition-colors border-b-2 ${
              activeTab === 'Penjualan Return'
                ? 'border-amber-500 text-amber-600 dark:text-amber-400'
                : 'border-transparent text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200'
            }`}
            onClick={() => {
              setActiveTab('Penjualan Return');
              setCurrentPage(1);
            }}
          >
            TRX Return
          </button>
        </div>

        <div className="bg-white dark:bg-slate-900 border-b border-slate-200 dark:border-slate-800">
          <div className="p-3 flex items-center gap-2 justify-between">
            <div className="flex-1 md:flex-none md:w-72">
              <Input
                className="input w-full h-[2.5rem] border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-900 dark:text-slate-100 placeholder:text-slate-400 focus:border-amber-500 focus:outline-none rounded-md transition-colors"
                type="text"
                onChange={(e) => setSearch(e.target.value)}
                value={search}
                autoComplete="off"
                placeholder="Cari Faktur / Kode"
              />
            </div>
            <div className="flex items-center gap-2">
              <FilterToggleButton
                onClick={() => setIsFilterOpen(true)}
                isOpen={isFilterOpen}
                activeFilterCount={activeFilterCount}
              />
              <button
                type="button"
                onClick={handleResetAndReload}
                className="bg-slate-800 hover:bg-slate-900 text-white h-[2.5rem] w-[2.5rem] rounded-md transition-colors shadow-sm flex items-center justify-center flex-shrink-0"
                title="Refresh & Reset Filter"
              >
                <IconReload className="w-4 h-4" />
              </button>
            </div>
          </div>
        </div>

        {/* Filter Drawer (muncul dari kanan layar) */}
        <FilterDrawer
          isOpen={isFilterOpen}
          onClose={() => setIsFilterOpen(false)}
          title="Filter Penjualan"
          subtitle="Filter transaksi penjualan"
          activeFilterCount={activeFilterCount}
          onReset={handleResetAndReload}
        >
          {/* Tanggal */}
          <div className="dropdown dropdown-bottom w-full">
            <div
              tabIndex={0}
              className="w-full h-10 border border-slate-200 dark:border-slate-600 rounded-xl px-3 text-xs sm:text-sm text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-800 cursor-pointer hover:border-amber-300 dark:hover:border-amber-500 flex items-center justify-between gap-1.5 shadow-xs"
              title="Filter Tanggal"
            >
              <div className="flex items-center gap-2 truncate">
                <IconCalendar size={16} className="text-amber-500 shrink-0" />
                <span className="truncate">
                  {startDate && endDate
                    ? awal === akhir
                      ? awal
                      : `${awal} - ${akhir}`
                    : 'Semua Waktu'}
                </span>
              </div>
            </div>
            <div
              tabIndex={0}
              className="dropdown-content menu p-2 shadow-2xl bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 z-[9999] mt-1 right-0 max-w-[92vw] overflow-x-auto"
            >
              <DateRange ranges={[selectionRange]} onChange={handleSelect} />
              {startDate && (
                <div className="p-2 border-t border-slate-200 dark:border-slate-700 flex justify-end">
                  <button
                    type="button"
                    onClick={() => {
                      setStartDate(null);
                      setEndDate(null);
                      setCurrentPage(1);
                    }}
                    className="text-xs text-rose-500 hover:underline font-bold cursor-pointer"
                  >
                    Reset Tanggal
                  </button>
                </div>
              )}
            </div>
          </div>

          {/* Etalase */}
          <select
            value={idCabang}
            onChange={(e) => {
              setIdCabang(e.target.value);
              setCurrentPage(1);
            }}
            className="w-full h-10 border border-slate-200 dark:border-slate-600 rounded-xl px-3 text-xs sm:text-sm text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-800 cursor-pointer hover:border-amber-300 dark:hover:border-amber-500 outline-none font-medium shadow-xs"
          >
            <option value="">Semua Etalase</option>
            {selectCabang.map((cb) => (
              <option value={cb.id} key={cb.id}>
                {cb.nama_cabang}
              </option>
            ))}
          </select>

          {/* Kategori */}
          <select
            value={selectedKategori}
            onChange={handleKategoriChange}
            className="w-full h-10 border border-slate-200 dark:border-slate-600 rounded-xl px-3 text-xs sm:text-sm text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-800 cursor-pointer hover:border-amber-300 dark:hover:border-amber-500 outline-none shadow-xs"
          >
            <option value="">Semua Kategori</option>
            {kategori.map((item) => (
              <option key={item.id} value={item.id}>
                {item.nama_kategori}
              </option>
            ))}
          </select>

          {/* Jenis Kategori */}
          <select
            onChange={handleJenisKategoriChange}
            value={selectJenisKategori}
            disabled={!selectedKategori}
            className={`w-full h-10 border border-slate-200 dark:border-slate-600 rounded-xl px-3 text-xs sm:text-sm text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-800 outline-none shadow-xs ${
              !selectedKategori
                ? 'opacity-50 cursor-not-allowed'
                : 'cursor-pointer hover:border-amber-300 dark:hover:border-amber-500'
            }`}
          >
            <option value="">Semua Jenis</option>
            {selectedKategori &&
              kategori
                .find((kt) => kt.id === parseInt(selectedKategori))
                ?.jenis_kategori?.map((jk) => (
                  <option key={jk.id} value={jk.id}>
                    {jk.nama_jenis}
                  </option>
                ))}
          </select>

          {/* Karat */}
          <KaratGridFilter
            selectedKarat={selectedKarat}
            onChange={(val) => {
              setSelectedKarat(val);
              setCurrentPage(1);
            }}
          />

          {/* Berat */}
          <div className="flex items-center gap-1.5">
            <Input
              value={filterBerat}
              onChange={(e) => setFilterBerat(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && filterBeratBarang()}
              placeholder="Cari Berat"
              className="flex-1 h-10 border-slate-200 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-900 dark:text-slate-100 placeholder:text-slate-400 focus:border-amber-500 focus:outline-none rounded-xl transition-colors"
            />
            <button
              type="button"
              onClick={filterBeratBarang}
              className="bg-amber-500 hover:bg-amber-600 text-white h-10 w-10 rounded-xl transition-colors shadow-sm flex items-center justify-center flex-shrink-0"
              title="Terapkan Berat"
            >
              <IconSearch className="w-4 h-4" />
            </button>
          </div>
        </FilterDrawer>
        <div className="dark:border-slate-700/60 pt-2">
          <DetailBarangPenjualan
            label={'Penjualan'}
            checkBerat={checkBerat}
            closeModal={closeModal}
            detailPenjualan={detailPenjualan}
            isOpen={isOpen}
          />
          {openLoading ? (
            <div className="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700/20 opacity-75 flex flex-col items-center justify-center">
              <div className="w-12 h-12 rounded-full animate-spin border-4 border-dashed border-amber-500 border-t-transparent"></div>
            </div>
          ) : (
            ''
          )}
          <div className="-mx-4 sm:-mx-8 px-4 sm:px-8 flex gap-2">
            <div className="inline-block min-w-full shadow-sm sm:rounded-lg overflow-hidden border border-slate-200 dark:border-slate-700">
              <div className="relative overflow-x-auto scrollbar-thin">
                <table className="min-w-full leading-normal">
                  <thead>
                    <tr className="bg-gradient-to-r from-amber-50 via-amber-100/80 to-amber-50 dark:from-amber-900/30 dark:via-amber-800/20 dark:to-amber-900/30">
                      <th scope="col" className="py-3 px-3 text-left text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider">
                        No
                      </th>
                      <th scope="col" className="py-3 px-3 text-left text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider">
                        Kode TRX
                      </th>
                      <th scope="col" className="py-3 px-3 text-left text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider">
                        Kode Barang
                      </th>
                      <th scope="col" className="py-3 px-3 text-left text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider">
                        Nama Barang
                      </th>
                      <th scope="col" className="py-3 px-3 text-left text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider">
                        Berat | Karat
                      </th>
                      <th scope="col" className="py-3 px-3 text-left text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider">
                        Harga
                      </th>
                      <th scope="col" className="py-3 px-3 text-left text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider">
                        Rata | Gram
                      </th>
                      <th scope="col" className="py-3 px-3 text-left text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider">
                        Kasir
                      </th>
                      <th scope="col" className="py-3 px-3 text-left text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider">
                        Tanggal
                      </th>
                      {activeTab === 'Penjualan Return' && (
                        <>
                          <th scope="col" className="py-3 px-3 text-left text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider">
                            Diproses Oleh
                          </th>
                          <th scope="col" className="py-3 px-3 text-left text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider">
                            Tgl Return
                          </th>
                        </>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <>
                        <tr className="flex  items-center justify-center">
                          <td className="w-5 h-5  rounded-full animate-spin border-4 border-dashed border-amber-500 border-t-transparent mt-4"></td>
                          <td className=" font-semibold px-2 py-4 rounded-md text-slate-500 dark:text-slate-400">Memuat data....</td>
                        </tr>
                      </>
                    ) : (
                      <>
                        {trxPenjualan.map((trx, i) => (
                          <tr
                            key={trx.id}
                            onClick={() => showDetailPenjualan(trx)}
                            className="hover:bg-amber-50 dark:hover:bg-slate-800/80 bg-white dark:bg-slate-900 cursor-pointer transition-colors border-b border-slate-100 dark:border-slate-700/50"
                          >
                            <td className="px-4 py-1.5 text-sm">
                              <p className="text-slate-900 dark:text-slate-300 whitespace-no-wrap font-medium">{startIndex + i + 1}.</p>
                            </td>
                            <td className="px-4 py-1.5 whitespace-nowrap text-sm">
                              <span className="font-semibold text-amber-900 dark:text-amber-400 bg-amber-100/70 dark:bg-amber-950/60 px-2 py-0.5 rounded border border-amber-200 dark:border-amber-800/60 font-mono text-xs">
                                {trx.kode_trx || '-'}
                              </span>
                            </td>
                            <td className="px-4 py-1.5 whitespace-nowrap text-sm">
                              <p className="text-amber-700 dark:text-amber-500 font-medium whitespace-no-wrap">{trx.item.kode_item}</p>
                            </td>
                            <td className="px-4 py-1.5 whitespace-nowrap text-sm">
                              <p className="text-slate-800 dark:text-slate-300 whitespace-no-wrap">
                                {trx.item?.jenis_kategori?.nama_jenis}{' '}
                                {trx.is_refund === true && (
                                  <span className="text-red-500 dark:text-red-400 text-xs font-medium ml-1.5 px-1.5 py-0.5 bg-red-50 dark:bg-red-900/20 rounded-md border border-red-200 dark:border-red-900/50">dikembalikan</span>
                                )}
                              </p>
                            </td>

                            <td className="px-4 py-1.5 whitespace-nowrap text-sm">
                              <p className="text-slate-800 dark:text-slate-300 whitespace-no-wrap">
                                <span className="font-medium">{trx.item?.berat} gr</span> <span className="text-slate-400 dark:text-slate-500">| {trx.item?.karat} krt</span>
                              </p>
                            </td>
                            <td className="px-4 py-1.5 whitespace-nowrap text-sm text-slate-800 dark:text-slate-300 font-medium">
                              Rp {numberWithCommas(trx.total_harga === undefined ? '0' : trx.total_harga)}
                            </td>
                            <td className="px-4 py-1.5 whitespace-nowrap text-sm text-slate-800 dark:text-slate-300">
                              Rp{' '}
                              {numberWithCommas(
                                trx.total_harga === undefined ? '0' : Math.round(trx.total_harga / trx.item?.berat),
                              )}{' '}
                              <span className="text-slate-400 dark:text-slate-500">/ gr</span>
                            </td>
                            <td className="px-4 py-1.5 whitespace-nowrap text-sm">
                              <p className="text-slate-800 dark:text-slate-300 whitespace-no-wrap">{trx.user?.name}</p>
                            </td>
                            <td className="px-4 py-1.5 whitespace-nowrap text-sm">
                              <p className="text-slate-800 dark:text-slate-300 whitespace-no-wrap">{trx.created_at}</p>
                            </td>
                            {activeTab === 'Penjualan Return' && (
                              <>
                                <td className="px-4 py-1.5 whitespace-nowrap text-sm">
                                  <p className="text-slate-800 dark:text-slate-300 font-medium whitespace-no-wrap">{trx.karyawan?.nama_karyawan || '-'}</p>
                                </td>
                                <td className="px-4 py-1.5 whitespace-nowrap text-sm">
                                  <p className="text-slate-800 dark:text-slate-300 whitespace-no-wrap">{trx.updated_at || '-'}</p>
                                </td>
                              </>
                            )}
                          </tr>
                        ))}
                      </>
                    )}
                    <tr className="bg-amber-50/50 dark:bg-slate-800/50 font-bold border-t-2 border-amber-200 dark:border-slate-700 text-slate-800 dark:text-slate-300">
                      <td colSpan={4} className="px-4 py-1.5 text-right">Total Berat Halaman Ini:</td>
                      <td className="px-4 py-1.5 whitespace-nowrap">{trxPenjualan.reduce((sum, trx) => sum + Number(trx.item?.berat || 0), 0).toFixed(2)} gr</td>
                      <td colSpan={activeTab === 'Penjualan Return' ? 6 : 4}></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="bg-slate-50 dark:bg-slate-800/50 border-t border-slate-200 dark:border-slate-700 py-3 transition-colors">
                <div className="flex justify-between items-center w-full px-5">
                  <div className="flex items-center space-x-2 text-sm text-slate-700 dark:text-slate-300">
                    <span>Tampilkan</span>
                    <select
                      value={perPage}
                      onChange={(e) => {
                        setPerPage(Number(e.target.value));
                        setCurrentPage(1);
                      }}
                      className="border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 rounded-md px-2 py-1 text-sm focus:outline-none focus:border-amber-500"
                    >
                      <option value={10}>10</option>
                      <option value={15}>15</option>
                      <option value={20}>20</option>
                      <option value={50}>50</option>
                    </select>
                    <span>data</span>
                  </div>
                  <div className="items-center flex justify-center space-y-2 text-sm sm:space-y-0 sm:space-x-3 sm:flex">
                    <span className="block text-slate-700 dark:text-slate-300 font-medium whitespace-nowrap">
                      Halaman
                      <input
                        type="text"
                        value={pageInput}
                        onChange={handlePageInputChange}
                        onBlur={jumpToPage}
                        onKeyDown={handlePageInputKeyDown}
                        className="w-12 h-7 mx-1.5 text-center border border-slate-200 dark:border-slate-600 rounded-md bg-white dark:bg-slate-800 text-amber-700 dark:text-amber-500 font-bold focus:border-amber-400 focus:ring-1 focus:ring-amber-200 outline-none transition-all"
                      />
                      dari <span className="font-bold text-amber-700 dark:text-amber-500">{lastPage}</span>
                    </span>
                    <div className="space-x-1">
                      <button
                        onClick={() => setCurrentPage(currentPage - 1)}
                        title="previous"
                        type="button"
                        className="inline-flex items-center justify-center w-8 h-8 py-0 border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 rounded-md shadow-sm transition-colors"
                      >
                        <IconChevronLeft className="w-4 h-4" />
                      </button>
                      <button
                        onClick={() => setCurrentPage(currentPage + 1)}
                        title="next"
                        type="button"
                        className="inline-flex items-center justify-center w-8 h-8 py-0 border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 rounded-md shadow-sm transition-colors"
                      >
                        <IconChevronRight className="w-4 h-4" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layouts>
  );
};

export default TrxPenjualanV2;
